export default __webpack_public_path__ + "static/media/ua.5dee4bea.svg";